import Container from '@mui/material/Container'
import styled from 'styled-components'

import { backgroundColor } from '../Colors'

// eslint-disable-next-line import/prefer-default-export
export const SafeAreaView = styled(Container)`
  background-color: ${backgroundColor};
`
